//DEFAULTS
//import "core-js/stable";
//import "regenerator-runtime/runtime";

import showtimesSidebar from 'site/showtimesSidebar'

$(document).ready(function() {
    showtimesSidebar.init()
})